module.exports = __webpack_public_path__ + "img/企业办公室样机.bc52934.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/企业办公室样机.png
// module id = zaTZ
// module chunks = 2